import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

const ModalContainer = ({ isOpen, closeModal, label, children, classes, size, onAfterOpen }) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={closeModal}
    contentLabel={label}
    className={`modal-inner modal-inner--${size} ${classes}`}
    overlayClassName={{ base: 'modal-new', afterOpen: 'modal-open', beforeClose: 'modal-closing' }}
    closeTimeoutMS={500}
    onAfterOpen={onAfterOpen}
  >
    {children}
  </Modal>
);

ModalContainer.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  label: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  classes: PropTypes.string,
  size: PropTypes.string,
  onAfterOpen: PropTypes.func,
};

export default ModalContainer;



// WEBPACK FOOTER //
// ./library/app/components/Global/Modals/ModalContainer.js